import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-x",
  templateUrl: "./med-icon-x.component.html",
})
export class MedIconXComponent extends SvgMixinComponent {}
